import { getIdToken } from '@podiumhq/foe-hammer';
import env from '../lib/env';

export async function getAuthHeader() {
  const idToken = await getIdToken(env.REACT_APP_ACCOUNT_URL || '', true);

  return { Authorization: `Bearer ${idToken}` };
}
